<div *ngIf="showIntro">
  <div class="intro-content">

    <div class="game-intro-text">
      <div class="button-container">
        <app-buttons-helping-toughts
        [disabled]="true"
        [disableHelping]="false"
        [disableHelping]="false"

        >
      </app-buttons-helping-toughts>
      </div>
      <p [innerHTML]="introText"></p>
    </div>
  </div>
  <app-button-next3 [disabled]="!enableEndIntro" (clicked)="introNext(); audio.playSoundClick();">
    {{audio.text.global.continue}}</app-button-next3>
</div>

<div *ngIf="!showIntro">
  <div class="popup-explanation large">
    <div class="explain-pin">
      <img [draggable]="false" src="/img/games/explain-pin.svg">
    </div>
    <!-- <h3 class="header">{{audio.text.games.instruction}}</h3> -->


    <p [innerHTML]="audio.getHTML('helpende_gedachten_uitleg')"></p>
  </div>

  <div class="question-progress">
    <app-question-number [value]="activeOptionId + 1"></app-question-number>
    <app-progress-bar [values]="progressBarData" [active]="activeOptionId"></app-progress-bar>
  </div>

  <h3 class="question">{{questionText}}</h3>
  <app-line></app-line>

  <div class="button-container">
    <app-buttons-helping-toughts
      [disabled]="disableOptions"
      [disableHelping]="(disableOptions && !helpingOptionSelected)"
      [disableNotHelping]="(disableOptions && !notHelpingOptionSelected)"
      (helpingClicked)="selectAnswer('helping');"
      (notHelpingClicked)="selectAnswer('nothelping');">
    </app-buttons-helping-toughts>

  </div>
  <app-line></app-line>
  <!--									THE NEXT-WRAP ELEMENT NEEDS THE CLASS "INVISIBLE" WHEN NOT IN THE ANSWER SCREEN-->
  <div class="next-wrap">
    <h4 class="footnote" [ngClass]="{'invisible':!showFootnote}"><span>{{feedbackText}}</span></h4>
    <app-button-next2 [disabled]="!enableNextButton" (click)="setNextQuestion();  audio.playSoundClick();">
      {{buttonCaption}}</app-button-next2>
  </div>
</div>
